import { render, staticRenderFns } from "./MakeRecordAndVideo.vue?vue&type=template&id=235727de&scoped=true"
import script from "./MakeRecordAndVideo.vue?vue&type=script&lang=js"
export * from "./MakeRecordAndVideo.vue?vue&type=script&lang=js"
import style0 from "./MakeRecordAndVideo.vue?vue&type=style&index=0&id=235727de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235727de",
  null
  
)

export default component.exports